import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import axios from '../../axios.js';



import '../Resources/dashboard.css';


function Loancrm_createleadbs(){


  
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");
 const busyid=sessionStorage.getItem("BusyId00");
 const counterid=sessionStorage.getItem("CounterId00");


 
//saving default values with usestate
const state = useState();


//customer_name
const[customer_name,setcustomer_name]=useState();const updatecustomer_name = (event) => { setcustomer_name(event.target.value);}; const[customer_name_er,setcustomer_name_er]=useState();
//email
const[email,setemail]=useState();const updateemail = (event) => { setemail(event.target.value);}; const[email_er,setemail_er]=useState();
//contact
const[contact,setcontact]=useState();const updatecontact = (event) => { setcontact(event.target.value);}; const[contact_er,setcontact_er]=useState();
//whatsapp
const[whatsapp,setwhatsapp]=useState();const updatewhatsapp = (event) => { setwhatsapp(event.target.value);}; const[whatsapp_er,setwhatsapp_er]=useState();
//address
const[address,setaddress]=useState();const updateaddress = (event) => { setaddress(event.target.value);}; const[address_er,setaddress_er]=useState();
//city
const[city,setcity]=useState();const updatecity = (event) => { setcity(event.target.value);}; const[city_er,setcity_er]=useState();
//cstate
const[cstate,setcstate]=useState();const updatecstate = (event) => { setcstate(event.target.value);}; const[cstate_er,setcstate_er]=useState();
//country
const[country,setcountry]=useState();const updatecountry = (event) => { setcountry(event.target.value);}; const[country_er,setcountry_er]=useState();
//pincode
const[pincode,setpincode]=useState();const updatepincode = (event) => { setpincode(event.target.value);}; const[pincode_er,setpincode_er]=useState();
//customer_type
const[customer_type,setcustomer_type]=useState();const updatecustomer_type = (event) => { setcustomer_type(event.target.value);}; const[customer_type_er,setcustomer_type_er]=useState();
//loan_requirement
const[loan_requirement,setloan_requirement]=useState();const updateloan_requirement = (event) => { setloan_requirement(event.target.value);}; const[loan_requirement_er,setloan_requirement_er]=useState();
//lead_type
const[lead_type,setlead_type]=useState();const updatelead_type = (event) => { setlead_type(event.target.value);}; const[lead_type_er,setlead_type_er]=useState();


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();




  
//******************* ADD CUSTOMER FUNCTION START ********************//
function addcustomer(){

 
      //disabling button
      document.getElementById('submit-btn').disabled = true; 


  //Setting Error Variables
setcustomer_name_er(" ");setemail_er(" ");setcontact_er(" ");setwhatsapp_er(" ");setaddress_er();setcity_er();setcstate_er();setcountry_er();setpincode_er();setcustomer_type_er();setloan_requirement_er();setlead_type_er();seterror_msg(" ");

 
  axios.post("loancrm-create-newlead", {
   Customer_name:customer_name,
   Email:email,
   Contact : contact,
   Whatsapp:whatsapp,
   Address:address,
   City:city,
   State:cstate,
   Country:country,
   Pincode:pincode,
   Customer_type:customer_type, //document.getElementById("customer_type").value,
   Loan_requirement:loan_requirement,
   Lead_type: lead_type, //document.getElementById("lead_type").value,
   Source:"Business Samadhan"

  })
  .then((response) => {

     //enabling button
     document.getElementById('submit-btn').disabled = false; 
    

  //Customers Limit Reached
  if(response.data.error==111){     seterror_msg(response.data.error_msg); return; }
    
  if(response.data.error==103){     seterror_msg(response.data.error_msg); return; }

   //Validation Errors
  else if(response.data.validatorerror){
  setcustomer_name_er(response.data.validatorerror.Customer_name);
  setemail_er(response.data.validatorerror.Email);
  setcontact_er(response.data.validatorerror.Contact);
  setwhatsapp_er(response.data.validatorerror.Whatsapp);
  setaddress_er(response.data.validatorerror.Address);
  setcity_er(response.data.validatorerror.City);
  setcstate_er(response.data.validatorerror.State);  
  setcountry_er(response.data.validatorerror.Country);
  setpincode_er(response.data.validatorerror.Pincode);  
  setcustomer_type_er(response.data.validatorerror.Customer_type);
  setloan_requirement_er(response.data.validatorerror.Loan_requirement);
  setlead_type_er(response.data.validatorerror.Lead_type);

}
//Invalid Entries
else if(response.data.error==102){ 
  setcustomer_name_er(response.data.customer_name_er);
  setemail_er(response.data.email_er);
  setcontact_er(response.data.contact_er);
  setwhatsapp_er(response.data.whatsapp_er);
  setaddress_er(response.data.address_er);
  setcity_er(response.data.city_er);
  setcstate_er(response.data.state_er);
  setcountry_er(response.data.country_er);
  setpincode_er(response.data.pincode_er);
  setcustomer_type_er(response.data.customer_type_er);
  setloan_requirement_er(response.data.loan_requirement_er);
  setlead_type_er(response.data.lead_type_er);
  seterror_msg("Cannot Complete Registration !");  }

 //Email Already Exists
 else if(response.data.error==103){  seterror_msg(response.data.error_msg); } 

   //Transaction Entered Successfully
  else if(response.data.successvar==1){  document.getElementById("success-card").style.display="block";  }
   //Cannot Add Transaction
   else{  seterror_msg("Cannot Complete Registration !"); }


  


});

 }
  
 //******************* ADD CUSTOMER FUNCTION END ********************//





return(
    <>

    

<html lang="en">
      <head>
        {/*} Required meta tags */}
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        <title>BUSINESS SAMADHAN | Loan Enquiry Form</title>
        {/*} plugins:css */}
        <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
        <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
        {/*} endinject */}
        {/*} Plugin css for this page */}
        <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
        <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
        {/*} End plugin css for this page */}
        {/*} inject:css */}
        {/*} endinject */}
        {/*} Layout styles */}
        <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
        {/*} End layout styles */}
        <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
      </head>
      <body>
    
    
        <div class="container-scroller">
    
      {/*}  <Sidebar /> */}
        <div class="container-fluid page-body-wrapper">
    
    
    
    
        {/*}   <Navbar />  */}
            {/*} partial */}
            <div class="main-panel">
    
              {/* ADD CUSTOMER SUCCESS CARD START */}
              <div class="d-flex justify-content-center">
              <div class="col-md-6 grid-margin stretch-card" style={{position:"fixed",zIndex:"3",marginTop:"4rem",display:"none"}} id="success-card">
                    <div class="card">
                      <div class="card-body">
                        <h4 class="card-title  text-success">Thanks for your Interest! Your Form is Submitted Successfully !!!</h4>
                      
                        <blockquote class="blockquote">
                          <p class="mb-0"> Our Team Will Get Back to You in 24 Hours.</p>
                          <a href="/"><button class="mt-3 btn btn-outline-danger">Close</button></a>
                        </blockquote>
                      </div>
                  
                    </div>
                  </div>
                  </div>
                  {/* ADD CUSTOMER SUCCESS CARD END */}
    
               
              
    
              <div class="content-wrapper pb-0">
    

                <div class="card" style={{textAlign:"left"}}>

                <div class="d-flex justify-content-between" style={{borderBottom:"0.2rem solid #d40d29", padding:"2rem"}}>
                  <div>
                    <img src="./images/imglogo.jpg" style={{height:"7rem", width:"15rem"}} />
                  </div>
                  <div class="">
                  <h2 style={{color:"#d40d29", textAlign:"right"}}>Business Samadhan Loan Enquiry Form</h2>
                  <p style={{textAlign:"right"}}><b>For any queries write us at:</b> info.businesssamadhan@gmail.com</p>
                  </div>
                </div>
             
                  <div class="card-body">
                    <h4 class="card-title">LOAN ENQUIRY FORM</h4>
                    <div class="form-sample">
                      <p class="card-description">add your personal details here</p>
                      <code>{error_msg}</code>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Name<code>*</code></label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Suman Kumar" id="customer_name" value={customer_name} onChange={updatecustomer_name} />
                              <code>{customer_name_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Email</label>
                            <div class="col-sm-9">
                              <input type="email" class="form-control" placeholder="sumankumar123@gmail.com" id="email" value={email} onChange={updateemail} />
                              <code>{email_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Contact</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 84754 00000" id="contact" value={contact} onChange={updatecontact} />
                              <code>{contact_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">WhatsApp</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="91 84754 00000" id="whatsapp" value={whatsapp} onChange={updatewhatsapp} />
                              <code>{whatsapp_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="exampleTextarea1">Address</label>
                        <textarea class="form-control" rows="2"  id="address" value={address} onChange={updateaddress} placeholder="64/A North Road"></textarea>
                        <code>{address_er}</code>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">City</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Lucknow" id="city" value={city} onChange={updatecity} />
                              <code>{city_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">State</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="Uttar Pradesh" id="cstate" value={cstate} onChange={updatecstate} />
                              <code>{cstate_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Country</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="India"  id="country" value={country} onChange={updatecountry}/>
                              <code>{country_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Pincode</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="420110" id="pincode" value={pincode} onChange={updatepincode} />
                              <code>{pincode_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Occupation</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Regular" style={{padding:"1rem"}} id="customer_type" value={customer_type} onChange={updatecustomer_type} >
                              <option value=" ">Select Option</option>
                              <option value="Salaried">Salaried</option>
                              <option value="Business">Business</option>
                              <option value="Other">Other</option>
                              </select>
                              <code>{customer_type_er}</code>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Loan Requirement<br/> (enter in numbers)</label>
                            <div class="col-sm-9">
                              <input type="text" class="form-control" placeholder="50000.00" id="loan_requirement" value={loan_requirement} onChange={updateloan_requirement} />
                              <code>{loan_requirement_er}</code>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <div class="form-group row">
                            <label class="col-sm-3 col-form-label">Looking for</label>
                            <div class="col-sm-9">
                              <select class="form-control" placeholder="Sub Category" id="lead_type" style={{padding:"1rem"}} value={lead_type} onChange={updatelead_type} >
                              <option value=" ">Select Option</option>
                              <option value="Business Loan">Business Loan</option>
                              <option value="Personal Loan">Personal Loan</option>
                              <option value="Home Loan">Home Loan</option>
                              <option value="Other">Other</option>
                              </select>
                              <code>{lead_type_er}</code>
                            </div>
                          </div>
                        </div>
                       
                      </div>
  
                        <button class="btn btn-lg btn-danger" style={{fontWeight:"bold", backgroundColor:"#d40d29"}} id="submit-btn" onClick={addcustomer}>Submit</button>
                      
                   
                    </div>
                  </div>
                </div>


            
                 
                   
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
        {/*}  <footer class="footer">
            <div class="d-sm-flex justify-content-center justify-content-sm-between">
              <span class="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span class="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i class="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
    </>

);

}

export default Loancrm_createleadbs;